import React, { useState, useEffect } from 'react';

const Footer = () => {
  const businessName = "Christophe Dépanne";
  const currentYear = new Date().getFullYear();

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setIsInstallable(false);
      setDeferredPrompt(null);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    try {
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') setIsInstallable(false);
      setDeferredPrompt(null);
    } catch (_) { }
  };

  return (
    <>
      <footer className="site-footer">
        <div className="footer-content-wrapper">
          <hr className="footer-divider" />

          {/* Grille Principale 3 Colonnes */}
          <div className="footer-grid">
            {/* Colonne 1 : Brand & App */}
            <div className="footer-col col-brand">
              <div className="brand-header">
                <img src="/images/logo.jpeg" alt="" className="footer-logo" />
                <span className="brand-footer-title">{businessName}</span>
              </div>
              {isInstallable && !isInstalled && (
                <button className="install-app-button" onClick={handleInstallClick}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M5 20h14v-2H5v2zM12 2v12l4-4h-3V2h-2v8H8l4 4z" />
                  </svg>
                  <span>Installer l'application</span>
                </button>
              )}
            </div>

            {/* Colonne 2 : Réseaux Sociaux */}
            <div className="footer-col col-social">
              <h4>Suivez-nous :</h4>
              <div className="social-links">
                <a href="https://www.youtube.com/@ChristopheD%C3%A9panne" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="#FF0000" style={{ minWidth: 22 }}>
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                  <span>YouTube</span>
                </a>
                <a href="https://www.tiktok.com/@christophedepanne" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="TikTok">
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="white" style={{ minWidth: 22 }}>
                    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.06-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
                  </svg>
                  <span>TikTok</span>
                </a>
                <a href="https://wa.me/33645219585" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="WhatsApp">
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="#25D366" style={{ minWidth: 22 }}>
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>

            {/* Colonne 3 : Navigation */}
            <div className="footer-col col-nav">
              <h4>Navigation</h4>
              <ul>
                <li><a href="/">Accueil</a></li>
                <li><a href="/mecanique">Mécanique</a></li>
                <li><a href="/vente-auto">Vente Auto</a></li>
                <li><a href="/blog">Blog</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p className="copyright">{currentYear} {businessName} - Tous droits réservés.</p>
            <p className="powered-by">
              Site propulsé par{" "}
              <a href="https://superbotboys.com" target="_blank" rel="noopener noreferrer">SuperBotBoys</a>
              {" "}et{" "}
              <a href="https://www.infocolab.com/" target="_blank" rel="noopener noreferrer">InfoColab</a>
            </p>
          </div>
        </div>
      </footer>

      <style>{`
        .site-footer {
          background-color: #1e293b;
          color: #f8fafc;
          padding: 60px 0 30px;
        }

        .footer-content-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .footer-divider {
          border: 0;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          margin: 40px 0;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 40px;
          margin-bottom: 50px;
        }

        .footer-col h4 {
          font-size: 1.2rem;
          margin-bottom: 25px;
          color: #ffffff;
          font-weight: 700;
        }

        /* Colonne Logo */
        .col-brand {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 25px;
        }
        .brand-header {
          display: flex;
          align-items: center;
          gap: 15px;
        }
        .brand-footer-title {
          font-size: 1.4rem;
          font-weight: 800;
          color: #ffffff;
        }
        .footer-logo {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #3b82f6;
        }

        /* Colonne Social */
        .social-links {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .social-link {
          display: flex;
          align-items: center;
          gap: 12px;
          color: #bdc3c7;
          text-decoration: none;
          transition: all 0.3s;
          font-weight: 500;
        }
        .social-link:hover { 
          color: #ffffff; 
          transform: translateX(5px);
        }
        .social-link img { width: 22px; height: 22px; }
        .tiktok-icon { filter: invert(0.8); }

        /* Colonne Nav */
        .col-nav ul {
          list-style: none;
          padding: 0;
        }
        .col-nav ul li { margin-bottom: 12px; }
        .col-nav ul li a {
          color: #bdc3c7;
          text-decoration: none;
          transition: all 0.3s;
        }
        .col-nav ul li a:hover { 
          color: #ffffff; 
          padding-left: 5px;
        }

        /* Bouton App */
        .install-app-button {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #3b82f6;
          color: white;
          border: none;
          padding: 12px 20px;
          border-radius: 10px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        .install-app-button:hover { 
          background: #2563eb; 
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.2);
        }

        /* Bottom */
        .footer-bottom {
          border-top: 1px solid rgba(255,255,255,0.1);
          padding-top: 30px;
          text-align: center;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .copyright { font-size: 0.9rem; color: #95a5a6; }
        .powered-by { font-size: 0.85rem; color: #7f8c8d; }
        .powered-by a { color: #bdc3c7; text-decoration: none; font-weight: 600; }
        .powered-by a:hover { color: #ffffff; text-decoration: underline; }

        @media (max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 40px;
          }
          .col-brand { align-items: center; }
          .brand-header { flex-direction: column; }
          .social-links { align-items: center; }
          .social-link:hover { transform: translateY(-3px); }
          .col-nav ul li a:hover { padding-left: 0; }
        }
      `}</style>
    </>
  );
};

export default Footer;